




































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import debounce from 'lodash.debounce';
import { UsersApi, User } from '../../api';
import { Validation } from 'vuelidate';
import { VueSelect } from 'vue-select';

@Component
export default class AdminSuggest extends Vue {
	// computed
	get validationState() {
		if (this.validator) {
			return this.validator.$dirty && this.validator.$invalid;
		}
		return null;
	}
	public collapseVisible = true;

	@PropSync('org')
	public localOrg!: object;

	@Prop(Object)
	public readonly validator?: Validation;

	@Prop(Boolean)
	public readonly disabled?: boolean;

	public options: User[] = [];
	private api: UsersApi;

	constructor() {
		super();
		this.api = new UsersApi();
		this.debouncedOptions = debounce(this.fetchOptions, 100);
	}

	public clearUser() {
		this.localOrg.admin = { name: '', email: '', phone: '' };
		this.$emit('exist', false);
	}

	public onSelect(item: any) {
		if (this.validator) {
			this.validator.$touch();
		}
		this.collapseVisible = !this.collapseVisible;
		this.localOrg.admin = item;
		this.$emit('exist', true);
	}

	public onSearch(search: string) {
		this.collapseVisible = true;
		if (!search || search.length < 1) {
			this.debouncedOptions.cancel();
			//   // loading(false);
			return;
		}
		this.debouncedOptions.cancel();
		this.debouncedOptions(search);
	}

	public async fetchOptions(search: string) {
		const options = {
			params: {
				'filter[name]': search,
				'fields[users]': 'id,name,email,phone',
			},
		};
		const response = await this.api.getUsers(options);
		const users = response.data.data || [];

		this.options = response.data.data || [];
	}

	private readonly debouncedOptions: any = () => {
		return [];
	};
}
